import { signal } from "@preact/signals-react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { EyeIcon } from "components/Icons";
import { cn } from "tools/ui";
import { UserIcon } from "components/Icons/linear";
import { MessageIcon, PhoneIcon } from "components/Icons";

function HeaderCard({
  number,
  party_contact,
  prospect_rec_name,
  city_rec_name,
  lead_origin_rec_name,
  start_date,
  end_date,
  color,
  deployCard,
}) {
  const partyName = prospect_rec_name || party_contact || "Sin cliente";
  const dateStart = start_date || "-";
  const dateEnd = end_date || "-";
  const city_ = city_rec_name || "-";
  const origin = lead_origin_rec_name || "-";

  return (
    <div
      className={cn(
        "px-3 pt-2 pb-2 rounded-t-md",
        color?.card,
        deployCard.value && "mb-2",
      )}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center overflow-hidden flex-1">
          <UserIcon className="w-4 h-4 fill-current mr-2 shrink-0" />
          <span className="font-semibold text-sm text-gray-800 truncate">
            {partyName}
          </span>
        </div>
        <span className="text-xs text-gray-500 ml-2 shrink-0">{number}</span>
      </div>
      <div className="flex items-center mt-1">
        <PhoneIcon className="w-3 h-3 fill-current mr-2 text-gray-400 shrink-0" />
        <span className="text-xs text-gray-600 truncate">{origin}</span>
      </div>
      <div className="flex items-center">
        <MessageIcon className="w-3 h-3 fill-current mr-2 text-gray-400 shrink-0" />
        <span className="text-xs text-gray-600 truncate">{city_}</span>
      </div>
      <div className="flex space-x-2 mt-1 text-xs text-gray-500">
        <span className="truncate">Ini: {dateStart}</span>
        <span className="truncate">Fin: {dateEnd}</span>
      </div>
    </div>
  );
}

function CardStatic({ record, color, handleModal, deployCard }) {
  const {
    number,
    prospect,
    party_contact,
    city,
    lead_origin,
    start_date,
    end_date,
    description,
  } = record;
  const prospectObj = record["prospect."];
  const partyObj = record["party."];
  const cityObj = record["city."];
  const originObj = record["lead_origin."];
  return (
    <div
      className={cn(
        "relative mb-2 shadow-md w-full cursor-move rounded-md border",
        "border-gray-300 hover:border-gray-400 transition-colors bg-white",
      )}
    >
      <HeaderCard
        number={number}
        prospect={prospect}
        prospect_rec_name={prospectObj?.rec_name || partyObj?.rec_name}
        party_contact={party_contact}
        city={city}
        city_rec_name={cityObj?.rec_name}
        lead_origin={lead_origin}
        lead_origin_rec_name={originObj?.rec_name}
        start_date={start_date}
        end_date={end_date}
        color={color}
        deployCard={deployCard}
      />

      <FooterCard
        item={record}
        description={description}
        handleModal={handleModal}
        deployCard={deployCard}
      />
    </div>
  );
}

function FooterCard({ item, handleModal, deployCard }) {
  return (
    <div className="px-3 py-2 bg-gray-50 rounded-b-md border-t border-gray-200">
        <div className="flex space-x-2 text-gray-400">
          <button type="button" onClick={() => handleModal(item)}>
            <EyeIcon className="size-5 fill-current" />
          </button>
          <button
            type="button"
            className={cn(
              "transition-transform duration-200",
              deployCard.value && "rotate-180",
            )}
            onClick={() => (deployCard.value = !deployCard.value)}
          >
          </button>
        </div>
      </div>
  );
}

function CardItem({ record, state, color, isOverlay, handleModal }) {
  const deployCard = signal(false);

  if (isOverlay) {
    return (
      <CardStatic
        record={record}
        color={color}
        handleModal={handleModal}
        deployCard={deployCard}
      />
    );
  }

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: record.id,
    data: {
      record,
      column: state,
    },
    animateLayoutChanges: () => false,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ?? "transform 200ms cubic-bezier(.2,.8,.2,1)",
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <CardStatic
        record={record}
        color={color}
        handleModal={handleModal}
        deployCard={deployCard}
      />
    </div>
  );
}

export default CardItem;
